import { LinearProgress } from "@material-ui/core";
import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { CircularProgress as CPMaterialUI } from "@material-ui/core";

const useStyles = makeThemedStyles("CircularProgress", (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    padding: "40px",
    justifyContent: "center",
  },
}));

const CircularProgress = (props: {}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CPMaterialUI />
    </div>
  );
};

export default CircularProgress;
